import { useMemo, useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import { v4 as uuidv4 } from 'uuid';

import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import SearchGuest from '@components/ui/search/SearchGuest/SearchGuest';
import { validateGuestsChildrenAges } from '@components/views/landing/components/booker/common/bookerUtils';
import STATIC_ROUTES from '@data/staticRoutes.json';
import { HotelTypes } from '@domain/hotel/hotelAutoComplate';
import clean from '@utils/cleanObject';

import DateSelection, { DateDataTypes } from './dateSelection';
import HotelSelection from './hotelSelection';
import {
  Content,
  DateWrapper,
  Label,
  SelectionWrapper,
  StyledButton,
  StyledContent,
  StyledLayout,
  Text,
} from './styled';
import { formatDate } from './utils';

const INITIAL_ROOMS: ListingSearchRoomInterface[] = [
  {
    adultCount: 2,
    childrenList: [],
    closable: true,
    error: false,
    id: uuidv4(),
    key: '1',
    title: '1. Oda',
  },
];

const HotelSearchBar = () => {
  const router = useRouter();

  const [dataHotel, setDataHotel] = useState<HotelTypes>(null);
  const [hotelRooms, setHotelRooms] = useState(INITIAL_ROOMS);
  const [dataDate, setDataDate] = useState<DateDataTypes | null>(null);
  const [isSubmit, setIsSubmit] = useState(false);

  const handleSubmit = () => {
    if (
      dataHotel &&
      dataDate?.endDate &&
      !validateGuestsChildrenAges(hotelRooms)
    ) {
      const hotelUrl = dataHotel?.url;
      const inDate = formatDate(dataDate?.startDate.toDate());
      const outDate = formatDate(dataDate?.endDate.toDate());

      const rooms = hotelRooms.map(
        (item) =>
          `${item.adultCount}${
            item.childrenList.length > 0 ? ',' : ''
          }${item.childrenList.map((item) =>
            item.age
              .toString()
              .replaceAll('/', '-')
              .split('-')
              .reverse()
              .join('-')
          )}`
      );

      const query = clean({
        in: inDate,
        out: outDate,
        room: rooms,
      });

      router.push({
        pathname: `${STATIC_ROUTES.hotelPathPrefix}/${hotelUrl}`,
        query,
      });
    }

    setIsSubmit(true);
  };

  const resetIsSubmit = () => {
    setIsSubmit(false);
  };

  const totalGuestCount = useMemo(() => {
    let count = 0;

    hotelRooms.forEach((room) => {
      count += room.adultCount + room.childrenList.length;
    });

    return count;
  }, [hotelRooms]);

  return (
    <StyledLayout data-testid='hotel-selection'>
      <StyledContent>
        <StyledContent>
          <HotelSelection
            onChange={(value) => {
              setDataHotel(value);
            }}
            isSubmit={isSubmit}
            resetIsSubmit={resetIsSubmit}
          />
          <DateWrapper>
            <DateSelection
              onChange={(value) => setDataDate(value)}
              isSubmit={isSubmit}
            />
          </DateWrapper>
          <SearchGuest
            popoverStyles={{
              marginTop: '-8px',
              width: '300px',
            }}
            isSingleLineDatePicker
            rooms={hotelRooms}
            setHotelRooms={setHotelRooms}
            renderParentComponent={() => (
              <SelectionWrapper>
                <Content>
                  <Label>Misafirler</Label>
                  <Text>{totalGuestCount} Misafir</Text>
                </Content>
              </SelectionWrapper>
            )}
          />
        </StyledContent>

        <StyledButton onClick={handleSubmit} data-testid='hotel-search-button'>
          <SearchOutlined />
          ARA
        </StyledButton>
      </StyledContent>
    </StyledLayout>
  );
};

export default HotelSearchBar;
